/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { Component } from 'react'

import { HashRouter, Route } from 'trux'
import UploadGame from './UploadGame'

class Uploader extends Component {

    constructor(props) {
        super(props)

        this.state = {
            teamName: null,
            teamId: null
        }
    }

    render() {
        return (
            <HashRouter>
                <div className="Uploader">
                    <Route path="/:team/game-editor/:game_id/edit" component={UploadGame} />
                    <Route path="/:team/game-editor/:game_id/upload" component={UploadGame} />
                    <Route path="/:team/game-editor/:game_id/uploader" component={UploadGame} />
                </div>
            </HashRouter>
        )
    }
}

export default Uploader

